import { Scope } from "@utils"
import { useSafeNavigation, useSafeRoute } from "../../../navigation/web/useSafeNavigation";
import { useCreationStackIntegration } from "@hooks";

const useCreateScheduledMessageCtrl = () => {
    const navigation = useSafeNavigation()
    const route: any = useSafeRoute()
    
    // Try to get route params, but handle case when not in navigation context
    let routeParams: { scope?: Scope } = route?.params || {};
    const {isVisible, completeStep, hideCreationStack, nextStep, updateStackData, currentStack} = useCreationStackIntegration()
    
    const goBack = () => {
        if (isVisible) {
            hideCreationStack()
        } else {
            navigation?.goBack()
        }
    }

    const navigateToCompose = (scheduledMessageId: string) => {
        if (isVisible) {
            // In modal context, update stack data and move to next step
            updateStackData?.({
                scheduledMessageId
            });
            nextStep();
        } else {
            // In navigation context, navigate normally
            (navigation as any).navigate('ComposeMessage', { 
                scheduledMessageId
            });
        }
    }

    const completeCreation = (messageData?: Record<string, any>) => {
        if (isVisible) {
            // In modal context, complete the step
            completeStep(messageData)
        } else {
            // In navigation context, go back
            navigation?.goBack()
        }
    }

    const getScopeFromRoute = () => {
        return routeParams.scope || currentStack?.data?.scope;
    }

    return {
        isStackVisible: isVisible,
        goBack,
        navigateToCompose,
        completeCreation,
        getScopeFromRoute
    }
}

export default useCreateScheduledMessageCtrl
